routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {
    $stateProvider

        .state('statistic', {
            url: '/statistics',
            abstract: true
        })

        .state('statistic.export', {
            url: '/{dispatcherType}/{messageType}/{id}/export/{statistic}/{startDate}/{endDate}/{link}',
            controller: 'StatisticExportCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/export.html'),
            params: { disabledDispatchers: [] },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:STATISTICS:EXPORT',
                parent: 'campaign.index'
            }
        })

        .state('statistic.automationexport', {
                url: '/{dispatcherType}/{messageType}/{id}/{automationId}/export/{statistic}/{startDate}/{endDate}/{link}',
            controller: 'StatisticExportCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/export.html'),
            params: { disabledDispatchers: [] },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:STATISTICS:EXPORT',
                parent: 'automation.index'
            }
        })
};